import { render, staticRenderFns } from "./documentsGridBlock.vue?vue&type=template&id=cebd7020&scoped=true"
import script from "./documentsGridBlock.vue?vue&type=script&lang=js"
export * from "./documentsGridBlock.vue?vue&type=script&lang=js"
import style0 from "./documentsGridBlock.vue?vue&type=style&index=0&id=cebd7020&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebd7020",
  null
  
)

export default component.exports